module.exports = __webpack_public_path__ + "img/search.aab7dac6.svg";